/** Small labelled field wrapper used across BookingModal / InquiryModal.
 *  v4.4.7 — optional `error` renders a concise red label under the input. */
export default function MFld({ label, children, error, testId }) {
  return (
    <label className="block" data-testid={testId}>
      <span className="block text-[10px] uppercase tracking-[0.25em] text-neutral-500 mb-1.5">{label}</span>
      {children}
      {error && (
        <span
          className="mt-1 block text-[11px] font-medium text-red-600"
          data-testid={testId ? `${testId}-error` : undefined}
        >
          {error}
        </span>
      )}
    </label>
  );
}
